import React from "react";
import { Typography, Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { useTranslation } from "react-i18next";
import { startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import CustomGridItem from "../ChartsLayout/CustomGridItem.jsx";
import { HiddenTypography, BarChartEmpty } from "../ChartsLayout/EmptyCharts.jsx";

export default function StepsAndDistanceBarChart({
  fitnessData,
  stepsAndDistanceRef,
  selectedWeek,
}) {
  // console.log("fitness data in StepsAndDistanceBarChart ", fitnessData);
  const weekStarts = startOfWeek(selectedWeek, { weekStartsOn: 1 });
  const weekEnds = endOfWeek(selectedWeek, { weekStartsOn: 1 });

  const weekDays = eachDayOfInterval({
    start: weekStarts,
    end: weekEnds,
  });

  const {t} = useTranslation("statistics");

  const getFitnessDataForADate = (date) => {
    const dateFormatted = format(date, "yyyy-MM-dd");
    const dayFitnessInsightsData = fitnessData.find(
      (data) => data.date === dateFormatted
    );

    return dayFitnessInsightsData
      ? {
          distance: dayFitnessInsightsData.distance
            ? dayFitnessInsightsData.distance
            : 0,
        }
      : 0;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ResponsiveCharts>
        {({ chartWidth }) => (
          <CustomGridItem>
            <Box ref={stepsAndDistanceRef}>
              <Typography
                sx={{
                  margin: {
                    xs: "20px 0",
                    sm: "20px 0",
                    md: "0 0 20px 0",
                    lg: "20px 0 0 20px",
                    xl: "20px",
                  },
                  textAlign: "center",
                }}
                variant="h6"
              >
               {t("charts.fitness.distanceTitle")}
              </Typography>
              {weekDays.some((day) => {
                const data = getFitnessDataForADate(day);
                return data && Object.values(data).some((val) => val > 0);
              }) ? (
                <>
                  <HiddenTypography />
                  <BarChart
                    xAxis={[
                      {
                        scaleType: "band",
                        data: weekDays.map((day) => format(day, "EEE")),
                        padding: 0.2,
                      },
                    ]}
                    series={[
                      {
                        data: weekDays.map(
                          (day) => getFitnessDataForADate(day).distance
                        ),
                        label: t("series.distance"),
                      },
                    ]}
                    width={chartWidth}
                    height={300}
                    borderRadius={10}
                    slotProps={{
                      legend: {
                        direction: "row",
                        position: { vertical: "top", horizontal: "middle" },
                        padding: -5,
                        itemMarkWidth: 20,
                        itemMarkHeight: 3,
                        markGap: 5,
                        itemGap: 5,
                      },
                    }}
                  />
                </>
              ) : (
                <>
                  <BarChartEmpty weekDays={weekDays} chartWidth={chartWidth} />
                </>
              )}
            </Box>
          </CustomGridItem>
        )}
      </ResponsiveCharts>
    </LocalizationProvider>
  );
}
